$( document ).ready(function() {
    var segments = location.pathname.split("/");

    if ((isInArray('evaluations', segments) || isInArray('res_evaluations', segments)) && isInArray('images', segments)) {
        initEvaluationImages();
        initImageCropper();
    }
    if(location.pathname.indexOf('evaluations/images') !== -1) {
        document.getElementById("save_image").addEventListener("click", uploadEvalImage);
    }

    function uploadEvalImage(e){
        $('#save_image').attr('disabled',true);
        e.preventDefault();
        var form = $("#uploadEvalImage");
        var data = new FormData(form[0]);
        if (form.find('#image').data('cropper') !== undefined) {
            form.find('#image').cropper('getCroppedCanvas').toBlob(function (blob) {
                var fileInput = form.find("input[type=file]");
                var filename = '';

                if(fileInput.hasOwnProperty(0)) {
                    fileInput = fileInput[0];
                    if(fileInput.files) {
                        fileInput = fileInput.files;
                        if(fileInput.hasOwnProperty(0)) {
                            fileInput = fileInput[0];
                            if(fileInput.name) {
                                filename = fileInput.name;
                            }
                        }
                    }
                }
                if(filename.length === 0) {
                    filename = 'property_image_url';
                }
                var id = form.find("input[type=file]").attr('data-id');
                var key = form.find("input[type=file]").attr('name');
                data.append(form.find("input[type=file]").attr('name'), blob, filename);
                data.append('id', id);
                data.append('field', key);
                data.append('file_name', key);
                $('#upload_image_modal').modal('close');
                $("#uploadEvalImage").find('input:text, input:file').val('');
                $(".comps-image").fadeTo("fast", 1);
                var output = $('.comps-image-container');
                output.css({'background': ''});
                var url = 'evaluations/upload_image';
                if(location.pathname.indexOf('/res_evaluations/images') !== -1) {
                    url = 'res_evaluations/upload_image';
                }
                upload(data, id, key,url,true);
            },"image/jpeg",0.75);
        }else{
            Materialize.toast('Please select image first.', 3000, 'red'); 
        }
    }
    function initImageCropper() {
        $('#property_image_url').change(function () {
            var input = this;
            var url = $(this).val();
            var ext = url.substring(url.lastIndexOf('.') + 1).toLowerCase();

            var ratio = 1.777;
            var name = $(this).attr('name');
            if(name == 'cover'){
                ratio = 3.142;
            }else if(name == 'table-of-contents'){
                ratio = 0.855;
            }else if(name == 'executive-summary-details'){
                ratio = 0.802;
            }else if(name == 'property-summary-top-image'){
                ratio = 1.363;
            }else if(name == 'property-summary-bottom-image'){
                ratio = 1.333;
            }else if(name == 'sub-property-1' || name == 'sub-property-2' || name == 'sub-property-3'){
                ratio = 1.237;
            }
            if (input.files && input.files[0] && (ext == "gif" || ext == "png" || ext == "jpeg" || ext == "jpg")) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    $('#uploadEvalImage').find('#image').attr('src', e.target.result);
                    $('#uploadEvalImage').find('#image').cropper({
                        aspectRatio: ratio,
                        strict: false,
                        guides: false,
                        highlight: false
                    });
                    $('#uploadEvalImage').find('.comps-image-container > .file-field').hide();
                };
                reader.readAsDataURL(input.files[0]);
            }
            $('#save_image').attr('disabled',false);
        });
    }

    function initEvaluationImages() {
        $('#view').modal({
                dismissible: true, // Modal can be dismissed by clicking outside of the modal
                opacity: 0.5, // Opacity of modal background
                inDuration: 300, // Transition in duration
                outDuration: 200, // Transition out duration
                startingTop: '4%', // Starting top style attribute
                endingTop: '10%', // Ending top style attribute
                ready: function (modal, trigger) { // Callback for Modal open. Modal and trigger parameters available.
                    $('#view-image').attr('src', $('body').attr('data-cdn-url') + $(trigger).attr('data-dir'));
                },
                complete: function () {
                    $('#view-image').attr('src', '');
                }
            }
        );

        $(".eval-image").click(function () {
            $("#property_image_url").attr("name",$(this).attr('data-key'));
            $("#property_image_input").attr("name",$(this).attr('data-key'));
            $('#upload_image_modal').modal({dismissible:false});
            $('#upload_image_modal').modal('open');
        });

        $(".extra-image").click(function () {
            $("#property_image_url").attr("name",'extra-image');
            $("#property_image_input").attr("name",'');
        });

        $('.eval-image-column').on('dragenter', function (e) {
            e.stopPropagation();
            e.preventDefault();

        });

        // Drag over
        $('.eval-image-column').on('dragover', function (e) {
            e.stopPropagation();
            e.preventDefault();
        });

        // Drop
        $('.eval-image-column').on('drop', function (e) {
            e.stopPropagation();
            e.preventDefault();
            var key = $(this).attr('data-key');
            var id = $(this).attr('data-id');


            if (typeof id !== 'undefined' ) {
                var file = e.originalEvent.dataTransfer.files;
                file = file[0];
                console.log(file);
                var mimeType= file.type;
                console.log(mimeType);
                if(mimeType.split('/')[0] === 'image')
                {
                    var reader = new FileReader();

                    reader.onload = function (e) {
                        var img = $("img[data-key='" + key + "']");
                        img.attr('src', e.target.result);
                        img.css('object-fit', 'cover');
                    };
                    reader.readAsDataURL(file);
                    upload(file, id, key,'evaluations/upload_image');

                }
                else
                {
                    alert("Only image file allow.");
                }
            }
        });

        function trackUploadProgress(e)
        {
            var currentProgress = 0;
            if(e.lengthComputable)
            {
                currentProgress = (e.loaded / e.total) * 100; // Amount uploaded in percent
                console.log(currentProgress);

                if( currentProgress == 100 )
                console.log('Progress : 100%');
            }
        }

    }
});